import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_z7rsufrbjc: FaireBrandEntity = {
  token: "b_z7rsufrbjc",
  type: "brand",
  name: "Wildfire Spice Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/96442ba26676e6d9da7b38cfd5da9297e5d2f6abe3135875fd626ce8d16a8c15.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/2e7e2e1e5ad2fcb85976185262497eaf259d75fa111288569015fddaed9d7176.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/96442ba26676e6d9da7b38cfd5da9297e5d2f6abe3135875fd626ce8d16a8c15.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/2e7e2e1e5ad2fcb85976185262497eaf259d75fa111288569015fddaed9d7176.jpeg",
  location: "Bend, OR, USA",
  minimumOrderDollars: 180,
  rating: 0,
  reviewCount: 0,
  isInsider: false,
  description:
    "Upgrade trail meals with the first powdered hot sauce made for the backcountry! Compact, resealable, compostable, flight-friendly and packed with real heat, vinegar & flavor. Each pouch is equal to a bottle of hot sauce.",
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:25:49.190Z",
    importedBy: "entity-db-cli",
  },
};
